import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';

import { useUIStore } from '@/app/model';
import { createTask } from '@/entities/task/api/tasks';
import type { TaskApiPayload } from '@/features/tasks/model/forms/useTaskForm';
import { useIsMobile } from '@/hooks/ui/useMediaQuery';
import TaskFormModal from '@/features/tasks/task-form-modal/TaskCreateModal';

export function CreateTaskAction() {
  const location = useLocation();
  const isMenuOpen = useUIStore((state) => state.isMenuOpen);
  const isCalendarOpen = useUIStore((state) => state.isCalendarOpen);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);

  const isMobile = useIsMobile();
  const isHomePage = location.pathname === '/';
  const isVisible = isMobile && !isMenuOpen && isHomePage && !isCalendarOpen;

  const handleCloseTaskModal = () => {
    setIsTaskModalOpen(false);
  };

  const handleTaskSubmit = async (taskData: TaskApiPayload) => {
    try {
      console.log(taskData);
      await createTask(taskData);
      toast.success('Задача создана');
      handleCloseTaskModal();
    } catch (error) {
      console.log(error);
      toast.error('Не удалось создать задачу');
    }
  };

  return (
    <>
      {isVisible && (
        <div className="fixed right-6 bottom-16 z-40">
          <button
            onClick={() => setIsTaskModalOpen(true)}
            className="flex h-14 w-14 items-center justify-center rounded-full bg-mobile-header shadow-lg transition-all duration-200 hover:scale-105 hover:shadow-xl active:scale-95"
            style={{
              marginBottom: '10px',
              color: 'rgba(48, 73, 109, 1)',
              border: '1px solid rgba(48, 73, 109, 0.6)',
            }}
            aria-label="Создать задачу"
          >
            <Plus className="h-6 w-6" />
          </button>
        </div>
      )}

      <TaskFormModal
        open={isTaskModalOpen}
        onClose={handleCloseTaskModal}
        onSubmit={handleTaskSubmit}
        mode="create"
        isLoading={false}
      />
    </>
  );
}
